interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  en?: string;
  subtitle?: string;
  align?: 'left' | 'center';
  dark?: boolean;
}

export default function SectionHeading({
  title,
  en,
  subtitle,
  align = 'center',
  dark = false,
}: SectionHeadingProps) {
  return (
    <div className={align === 'center' ? 'text-center max-w-3xl mx-auto' : 'max-w-3xl'}>
      <h2
        className={`font-heading font-bold text-3xl md:text-[2.5rem] leading-tight tracking-tight ${
          dark ? 'text-background-50' : 'text-foreground-950'
        }`}
      >
        {title}
      </h2>
      {en && (
        <div
          className={`mt-3 text-xs md:text-sm font-medium tracking-[0.32em] uppercase ${
            dark ? 'text-foreground-400' : 'text-foreground-400'
          }`}
        >
          {en}
        </div>
      )}
      <div
        className={`mt-4 h-px w-12 ${align === 'center' ? 'mx-auto' : ''} ${
          dark ? 'bg-background-50/25' : 'bg-background-300'
        }`}
      />
      {subtitle && (
        <p
          className={`mt-5 text-sm md:text-base leading-relaxed ${
            dark ? 'text-foreground-300' : 'text-foreground-600'
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}